import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Leaf } from 'lucide-react';
import { useScreenInit } from '../../useScreenInit';
export function Splash() {
  useScreenInit();
  const navigate = useNavigate();
  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/welcome');
    }, 2500);
    return () => clearTimeout(timer);
  }, [navigate]);
  return <div className="min-h-screen bg-brand-primary flex flex-col items-center justify-center text-white p-6 relative overflow-hidden" data-id="element-194">
      {/* Background decorative elements */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-white/5 rounded-full -mr-20 -mt-20 blur-3xl" data-id="element-195"></div>
      <div className="absolute bottom-0 left-0 w-80 h-80 bg-brand-secondary/20 rounded-full -ml-20 -mb-20 blur-3xl" data-id="element-196"></div>

      <motion.div initial={{
      scale: 0.8,
      opacity: 0
    }} animate={{
      scale: 1,
      opacity: 1
    }} transition={{
      duration: 0.8,
      ease: 'easeOut'
    }} className="flex flex-col items-center z-10" data-id="element-197">
        <div className="w-24 h-24 bg-white rounded-3xl flex items-center justify-center shadow-2xl mb-6" data-id="element-198">
          <Leaf className="w-12 h-12 text-brand-primary" data-id="element-199" />
        </div>
        <h1 className="text-4xl font-heading font-bold mb-2 tracking-tight" data-id="element-200">
          FortuneBridge
        </h1>
        <p className="text-brand-primary-light text-opacity-90 font-medium text-center max-w-[250px]" data-id="element-201">
          Empowering Africa's Future Entrepreneurs
        </p>
      </motion.div>

      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1.5,
      duration: 0.5
    }} className="absolute bottom-12 z-10" data-id="element-202">
        <div className="flex space-x-2" data-id="element-203">
          <div className="w-2 h-2 bg-white rounded-full animate-bounce" style={{
          animationDelay: '0ms'
        }} data-id="element-204"></div>
          <div className="w-2 h-2 bg-white rounded-full animate-bounce" style={{
          animationDelay: '150ms'
        }} data-id="element-205"></div>
          <div className="w-2 h-2 bg-white rounded-full animate-bounce" style={{
          animationDelay: '300ms'
        }} data-id="element-206"></div>
        </div>
      </motion.div>
    </div>;
}